/* eslint-disable no-param-reassign */

import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import BasePositional from './BasePositional';

const DateRange = 24 * 60 * 60 * 1000;

const getIndex = createSelector(
    ({arrivalTime}) => arrivalTime,
    ({indices}) => indices[0].date,
    (arrivalTime, firstDate) => {
        if (!arrivalTime) return null;

        const arrivalRange = new Date(arrivalTime) - new Date(firstDate);
        const index = (arrivalRange / DateRange) * 24;

        if (index > 23) return null;

        return index;
    },
);

const BaseRouteArrivalTime = ({index, children, ...props}) => {
    if (index === null) return null;

    return (
        <BasePositional {...props} id="route-arrival-time" index={index}>
            {children}
        </BasePositional>
    );
};

const mapStateToProps = state => ({
    index: getIndex(state),
});

export default connect(mapStateToProps)(BaseRouteArrivalTime);
